import './index.scss';
import './modules/headerContainer';
import React from 'react';
import Container from './modules/container';

function App() {
  return (
    <div className="App">
      <Container />
    </div>
  );
}

export default App;
